<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">添加物品</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-form :model="addForm" :rules="rules" ref="addForm">

          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="选择机构">
                <el-select v-model="institutionCode" disabled placeholder="请选择机构" style="width: 100%">
                  <el-option
                      v-for="item in arr_ins"
                      :key="item.institutionCode"
                      :label="item.userName"
                      :value="item.institutionCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12" class="item">
              <el-form-item label="选择物品" required prop="waresName">
                <el-input v-model="addForm.waresName" placeholder="选择物品" disabled>
                  <el-button slot="append" icon="el-icon-search" @click="getWares"></el-button>
                  <el-button slot="prepend" icon="el-icon-close" @click="clearWares"></el-button>
                </el-input>
              </el-form-item>
            </el-col>

          </el-row>
          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="物品出库数量" required prop="count">
                <el-input v-model="addForm.count" type="number" placeholder="输入出库数量" style=""></el-input>
              </el-form-item>
            </el-col>

          </el-row>

        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">提交</el-button>
      </div>
    </div>

    <SelectWares ref="mySelectWares" v-show="showModalWares"
                 v-on:closeWares="showModalWares=false"
                 v-on:setWares="setWares"></SelectWares>

  </div>
</template>

<script>

import { timeStr} from "@/common/times";
import {getStaffCode} from "@/utils/auth";

import SelectWares from "./SelectWares";


export default {
  name: 'Add',
  props:['arr_ins'],
  data() {
    return {

      loading: false,

      showModalWares:false,

      addForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),

        waresCode:'',
        waresName:'',
        row:'',
        count:'',

      },

      institutionCode:'',


      rules:{
        waresName:[
          { required: true, message: '请选择物品', trigger: 'blur' },
          { required: true, message: '请选择物品', trigger: 'change' },
        ],
        count:[
          { required: true, message: '请输入出库数量', trigger: 'blur' },
        ],

      }


    }
  },
  components:{
    SelectWares
  },
  methods: {
    init(insCode){
      this.institutionCode = insCode;
      this.$refs.addForm.resetFields();

    },
    closeSelf() {
      this.$emit("closeAdd");
    },


    getWares(){
      this.showModalWares = !this.showModalWares;
      this.$refs.mySelectWares.init(this.institutionCode);
    },
    setWares(row){
      this.addForm.waresCode = row.waresCode;
      this.addForm.waresName = row.name;
      this.addForm.row = row;
    },
    clearWares(){
      this.addForm.waresCode = '';
      this.addForm.waresName = '';
      this.addForm.row = '';
    },


    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){

          if(this.addForm.count<=0){
            this.$message.info("出库数量有误");
            return ;
          }

          if(this.addForm.row.stock < this.addForm.count){
            this.$message.info("库存不足");
            return ;
          }

          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },


    addSubmit(){

      let r = this.addForm.row;
      r.count=this.addForm.count;

      this.$emit("getWares",r);

      this.$emit("closeAdd");
      this.$emit("getList");

    },


  }
}


</script>
<style lang="scss" scoped>

</style>
